import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { environment } from '@environment/environment';
import { LoggerService } from '@app/core/infrastructure';
import * as Sentry from '@sentry/angular';

// CRITICAL: Import compiler for JIT compilation (required for NgModule apps in Angular 20+)
// Without this, NgRx dependency injection will fail and Actions will be undefined
import '@angular/compiler';

// Initialize Sentry for error tracking (staging only)
if (environment.sentry?.enabled) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    // Lower sample rate for production, full sampling for other environments
    tracesSampleRate: environment.sentry.environment === 'production' ? 0.1 : 1.0,
    // GDPR compliance - don't send PII data
    sendDefaultPii: false
  });
}

platformBrowser().bootstrapModule(AppModule)
  .then(moduleRef => {
    // Expose logger globally in development for easy debugging
    if (!environment.production) {
      try {
        const logger = moduleRef.injector.get(LoggerService);
        (window as any).logger = logger;
        logger.debug('✅ Logger service exposed globally as window.logger');
        logger.debug('📖 Usage: window.logger.enableScopes("AudioEffects")');
        logger.debug('📖 See src/app/core/infrastructure/logging/README.md for more info');
      } catch (error) {
        console.warn('⚠️ Failed to expose logger globally:', error);
      }
    }
  })
  .catch(err => console.error(err));